import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currencyPageOpen: false,
    status: null,
    selectedCurrency: null,
    currencySymbol: null,
    currencyRate: null,
    currencyName: null
};

export const CurrencySlice = createSlice({
    name: "currency",
    initialState,
    reducers: {
        openCurrencyForm: (state, action) => {
        state.currencyPageOpen = action.payload;
        },

        setCurrencyStatus: (state, action) => {
            state.status = action.payload;
        },

        setSelectedCurrency: (state, action) => {
            state.selectedCurrency = action.payload;
        },

        setCurrencySymbol: (state, action) => {
            state.currencySymbol = action.payload;
        },

        setCurrencyRate: (state, action) => {
            state.currencyRate = action.payload;
        },

        setCurrencyName: (state, action) => {
            state.currencyName = action.payload;
        },
    },
});

export const { 
    openCurrencyForm, 
    setCurrencyStatus, 
    setSelectedCurrency,
    setCurrencySymbol,
    setCurrencyRate,
    setCurrencyName
} = CurrencySlice.actions;

export default CurrencySlice.reducer;